<template>
  <div class="column items-center">
    <p class="q-ma-none">
      <strong>{{ data.shipper.firstName }} {{ data.shipper.lastName }}</strong>
    </p>
    <strong><p class="q-ma-none">{{ phone }}</p></strong>
    <strong><p class="q-ma-none">{{ data.shipper.email }}</p></strong>
  </div>
</template>

<script>
  import { rrUnFormatPhoneNumber } from '@client/utils/app-helpers';

  export default {
    name: 'AppQuoteShipper',
    props: ['data'],
    computed: {
      phone() {
        return rrUnFormatPhoneNumber(this.$options.filters.phoneNumber(this.data?.shipper?.phone));
      }
    }
  };
</script>
